import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchCustomizedTripsDtlbannersec } from "../services/CustomizedTripsDtlbannersec";

const CustomizedTripsDtlcoversdside = () => {
  const { id } = useParams();
  const [CustomizedTripsDtl, setCustomizedTripsDtl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadBanner = async () => {
      const res = await fetchCustomizedTripsDtlbannersec(decodeURIComponent(id));

      if (res?.status && res?.data?.length > 0) {
        setCustomizedTripsDtl(res.data[0]);
      }
      setLoading(false);
    };

    loadBanner();
  }, [id]);

  if (loading) return <div>Loading...</div>;
  if (!CustomizedTripsDtl) return <div>No data found</div>;

  // Split covered_place into array of destinations
  const destinations = CustomizedTripsDtl.covered_place
    ? CustomizedTripsDtl.covered_place
        .split(",")
        .map((place) => place.trim())
        .filter(Boolean)
    : [];

  return (
     <div className="hidden lg:block lg:col-span-1">
      <div className="sticky top-4 space-y-6">
        <div className="rounded-lg bg-card text-card-foreground shadow-sm border-2 border-primary/20">
        <div className="p-6">
            <div className="text-center mb-6">
        {Number(CustomizedTripsDtl.charges) !== 0 && (
            <p className="text-sm text-slate-600 mb-2">Starting from</p>
        )}
            <p className="text-3xl font-bold bg-gradient-to-r from-primary to-purple-600 bg-clip-text text-transparent">
                {Number(CustomizedTripsDtl.charges) === 0 ? "Customised" : `₹${CustomizedTripsDtl.charges}`}
            </p>
        {Number(CustomizedTripsDtl.charges) !== 0 && (
            <p className="text-sm text-slate-500">per person</p>
        )}
            </div>
            <a target="_blank" href="https://wa.me/918920866123" className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary hover:bg-primary/90 h-10 px-4 py-2 w-full bg-gradient-to-r from-primary to-purple-600 hover:from-primary/90 hover:to-purple-600/90 text-white mb-3">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-phone mr-2 h-4 w-4"
            >
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
            </svg>
            Call to Book
            </a>
            <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border hover:text-accent-foreground h-10 px-4 py-2 w-full border-primary text-primary hover:bg-primary/10 bg-transparent">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-mail mr-2 h-4 w-4"
            >
                <rect width={20} height={16} x={2} y={4} rx={2} />
                <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
            </svg>
            Get Quote
            </button>
            <div className="mt-6 pt-6 border-t border-slate-200 space-y-3 text-sm text-slate-600">
            <div className="flex items-center gap-2">
                <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-check-circle h-4 w-4 text-primary"
                >
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                <path d="m9 11 3 3L22 4" />
                </svg>
                <span>Best Price Guarantee</span>
            </div>
            <div className="flex items-center gap-2">
                <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-check-circle h-4 w-4 text-primary"
                >
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                <path d="m9 11 3 3L22 4" />
                </svg>
                <span>24/7 Support</span>
            </div>
            <div className="flex items-center gap-2">
                <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-check-circle h-4 w-4 text-primary"
                >
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                <path d="m9 11 3 3L22 4" />
                </svg>
                <span>Flexible Customization</span>
            </div>
            </div>
        </div>
        </div>

       
       <div className="rounded-lg border bg-card text-card-foreground shadow-sm">
          <div className="p-6">
            <h3 className="font-bold text-slate-900 mb-4 flex items-center gap-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-map-pin h-5 w-5 text-primary"
              >
                <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                <circle cx={12} cy={10} r={3} />
              </svg>
              Destinations Covered
            </h3>

            <div className="flex flex-wrap gap-2">
              {destinations.map((place, index) => (
                <div
                  key={index}
                  className="text-white inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80 text-xs"
                >
                  {place}
                </div>
              ))}
            </div>
          </div>
        </div>


        <div className="rounded-lg border bg-card text-card-foreground shadow-sm">
        <div className="p-6">
            <h3 className="font-bold text-slate-900 mb-4">Customer Rating</h3>
            <div className="flex items-center gap-2 mb-2">
            <div className="flex">
                <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-star h-5 w-5 fill-yellow-400 text-yellow-400"
                >
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                </svg>
                <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-star h-5 w-5 fill-yellow-400 text-yellow-400"
                >
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                </svg>
                <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-star h-5 w-5 fill-yellow-400 text-yellow-400"
                >
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                </svg>
                <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-star h-5 w-5 fill-yellow-400 text-yellow-400"
                >
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                </svg>
                <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-star h-5 w-5 fill-yellow-400 text-yellow-400"
                >
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                </svg>
            </div>
            <span className="font-bold text-slate-900">4.9/5</span>
            </div>
            <p className="text-sm text-slate-600">Based on 200+ reviews</p>
        </div>
        </div>
    </div>
    </div>
  );
};

export default CustomizedTripsDtlcoversdside;
